import * as Dialog from '@radix-ui/react-dialog'
import { Button } from '@/ui/button'
import { MaterialIcon } from '@/ui/material-icon'
import styles from './ConfirmDialog.module.scss'

interface ConfirmDialogProps {
    open: boolean
    title: string
    message: string
    confirmText?: string
    cancelText?: string
    onConfirm: () => void
    onCancel: () => void
    onOpenChange?: (open: boolean) => void
}

export function ConfirmDialog({
    open,
    title,
    message,
    confirmText = 'Confirm',
    cancelText = 'Cancel',
    onConfirm,
    onCancel,
    onOpenChange,
}: ConfirmDialogProps) {
    return (
        <Dialog.Root open={open} onOpenChange={(next) => {
            if (!next) onCancel()
            onOpenChange?.(next)
        }}>
            <Dialog.Portal>
                <Dialog.Overlay className={styles.overlay} />
                <Dialog.Content className={styles.content}>
                    <div className={styles.header}>
                        <Dialog.Title className={styles.title}>{title}</Dialog.Title>
                        <Dialog.Close asChild>
                            <button className={styles.closeBtn} onClick={onCancel} aria-label="Close">
                                <MaterialIcon name="close" size={16} />
                            </button>
                        </Dialog.Close>
                    </div>
                    <Dialog.Description className={styles.description}>{message}</Dialog.Description>
                    <div className={styles.actions}>
                        <Button variant="secondary" onClick={onCancel}>{cancelText}</Button>
                        <Button onClick={onConfirm}>{confirmText}</Button>
                    </div>
                </Dialog.Content>
            </Dialog.Portal>
        </Dialog.Root>
    )
}
